module.exports = __webpack_public_path__ + "img/logo-mini.36c2f3ba.png";